/* eslint-disable */
import React from 'react';
import { makeStyles, Theme, createStyles, Typography } from '@material-ui/core';
import { flagsMap } from '../utils/flagsMapper';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: theme.palette.background.paper,
      padding: theme.spacing(1),
      boxShadow: "1px 1px 3px black"
    }
  }));
export function CustomTooltip(props) {
  const classes = useStyles();
  const data = props.api.getDisplayedRowAtIndex(props.rowIndex).data;
  const commodity = props.column.colId.split('_')[0];
  const country = data['Country'];
  const value = data[commodity]; 
  const flag = String(data['_code']).toLowerCase(); 
  return (<div className={classes.root}>
    <p>{commodity}</p>
    <p><span style={{ marginRight: "8px", boxShadow: '1px 1px 3px black' }} className={`flag-icon flag-icon-${flag}`}></span>
    
      {country}: {value}
    </p>
  </div>)
}